import { Checkbox } from "@/components/ui/checkbox";
import {
  FormControl,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form";
import { Variant } from "@/types/variant";
import { useFormContext, useFormState } from "react-hook-form";
import { useTranslation } from "react-i18next";

interface VariantListProps {
  variants: Variant[];
  index: number;
}

export default function VariantList({ variants, index }: VariantListProps) {
  const { t } = useTranslation();
  const { setValue, watch } = useFormContext();

  const { isSubmitting, disabled } = useFormState();

  const dependentOnValue = watch(`questions.${index}.dependentOnValue`) || [];

  const getVariantText = (variant: string) => {
    if (variant.trim() === "") {
      return t("dependentQuestions.unnamedVariant");
    }
    return variant;
  };

  const isActive = (variant: string) => dependentOnValue.includes(variant);

  const toggle = (variant: string) => {
    if (!isActive(variant)) {
      setValue(`questions.${index}.dependentOnValue`, [
        ...dependentOnValue,
        variant,
      ]);
    } else {
      setValue(
        `questions.${index}.dependentOnValue`,
        dependentOnValue.filter((v: string) => v !== variant),
      );
    }
  };

  return (
    <section className="mt-2 flex flex-col gap-2">
      {variants.map(({ variant }, index) => {
        const onCheckedChange = (variant: string) => {
          toggle(variant);
        };

        return (
          <FormItem
            className="flex flex-row items-center space-y-0"
            key={index}
          >
            <FormControl>
              <Checkbox
                onCheckedChange={() => onCheckedChange(variant)}
                checked={isActive(variant)}
                className="mr-2"
                disabled={isSubmitting || disabled}
              />
            </FormControl>
            <FormLabel className="truncate">
              {getVariantText(variant)}
            </FormLabel>
            <FormMessage />
          </FormItem>
        );
      })}
    </section>
  );
}
